import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { history } from 'utils';
import logo from './assets/icon.png';
import { menuItens, menuRoutes } from './menuItens';

class MenuComponent extends React.Component {
  state = {
    currentPath: history.location.pathname,
  };

  // componentDidUpdate() {
  //   const { pathname } = history.location;
  //   if (pathname !== this.state.currentPath) {
  //     this.setState({ currentPath: pathname });
  //   }
  // }

  onRouteChange = (e: React.MouseEvent) => {
    const route = e.currentTarget.getAttribute('href');
    this.setState({ currentPath: route });
  };

  renderMenuItens() {
    let { currentPath } = this.state;
    currentPath = currentPath === '/signout' ? '/' : currentPath;

    return menuItens.map(({ name, route, icon }) => (
      <Link
        to={route}
        key={name}
        onClick={this.onRouteChange}
        className={`item ${currentPath === route ? 'active' : ''}`}
      >
        <IconContainer>
          <i className={icon} />
        </IconContainer>
        <span style={{ marginLeft: '1em' }}>{name}</span>
      </Link>
    ));
  }

  render() {
    history.listen((location, action) => {
      const { pathname } = location;
      const lastIndex = pathname.lastIndexOf('/');
      const page = lastIndex > 0 ? pathname.substring(0, lastIndex) : pathname;

      if (page !== this.state.currentPath) {
        this.setState({ currentPath: page });
      }
    });

    return (
      <div
        className='ui secondary vertical pointing menu'
        style={{ position: 'fixed', height: '100%' }}
      >
        <div className='header'>
          <Link to={menuRoutes.ARTISTAS}>
            <img
              className='ui tiny centered image'
              src={logo}
              alt='Favid Logo'
            />
          </Link>
        </div>
        {this.renderMenuItens()}
      </div>
    );
  }
}

export const Menu = MenuComponent;

const IconContainer = styled.small`
  float: left;
  width: 2em;
`;
